var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service-no-moist-alarm"},[_c('alarm-status',{attrs:{"alarm":_vm.alarm,"alarm-active":_vm.computedAlarmIsActive}}),(_vm.computedAlarmIsActive)?_c('moisture-component',{staticClass:"g-alarm-handler__row",attrs:{"moisture":_vm.computedMoist,"store":_vm.store}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }